import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Text } from "@chakra-ui/react";
import { PlanType } from "sdk/types";
import { useTrialDiscount } from "~/MemberApp/hooks";
import { Trans } from "~/utils/i18next";
import { MembershipSelectAction } from "../hooks";
import { PlanBoxDiscountedPrice } from "./PlanBoxDiscountedPrice";
import { PlanBoxPrice } from "./PlanBoxPrice";

interface Props {
  action: MembershipSelectAction;
  plan: PlanType;
  type: PlanType;
}

export const PlanBoxAmount: FC<Props> = ({ action, plan, type }) => {
  const { t } = useTranslation();
  const trialDiscount = useTrialDiscount();
  const base = `planSelect.${action}.${type}` as const;
  const hasTrialDiscount = !!trialDiscount?.discount;
  const discountPrice =
    trialDiscount &&
    trialDiscount.discount &&
    trialDiscount[plan] &&
    trialDiscount[plan].discountPrice;

  const monthlyAmountStem = `planSelect.monthlyAmount.${type}` as const;
  const monthlyAmount = <Trans i18nKey={monthlyAmountStem} />;
  const originalAmount = <Trans i18nKey={`${base}.price.amount`} />;
  const originalTerm = <Trans i18nKey={`${base}.price.term`} />;
  const discountTerm = <Trans i18nKey="planSelect.discountTerm" />;
  const price = discountPrice || originalAmount;
  const term = hasTrialDiscount ? discountTerm : originalTerm;
  const termColor = hasTrialDiscount ? "th.blueGreen2" : undefined;

  return (
    <Flex align="center" direction="column">
      <Flex
        align={{ base: "center", md: "initial" }}
        direction={{ base: "column", md: "row" }}
        gap={{ base: 2, md: 0 }}
      >
        {hasTrialDiscount && (
          <PlanBoxDiscountedPrice amount={monthlyAmount} term={originalTerm} />
        )}
        <PlanBoxPrice color={termColor} amount={price} term={term} />
      </Flex>
      {hasTrialDiscount && (
        <Text
          color="th.gray4"
          mt={{ base: 2, md: 6 }}
          mb={4}
          variant="th-body3"
        >
          <Trans
            i18nKey="planSelect.extend.postDiscountDescription"
            values={{
              priceAndTerm: t(monthlyAmountStem),
            }}
          />
        </Text>
      )}
    </Flex>
  );
};
